export class DataSetCreateRequest {
    public dataSetName: string;
    public database: string;
    public query: string;
    public datetimeLastProcess: Date;
    public fullyProcessed: boolean = false;
}